export default "__VITE_ASSET__CQIupOVm__"